import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1681505531034-8d67054e07f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHw0fHxhZHZpc29yJTIwY29uc3VsdGF0aW9uJTIwbWVldGluZyUyMGhhbmRzaGFrZXxlbnwwfHx8fDE3ODg0MzkwNDB8MA&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <section id="about" className="bg-white py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2">
        <div>
          <Reveal>
            <Chapter number="03" label="Our Story" />
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-display text-3xl font-extrabold tracking-[-0.03em] text-slate-900 sm:text-4xl lg:text-5xl">
              Simplifying your journey to <span className="text-sky-600">Australia</span>
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-6 text-base leading-relaxed text-slate-600 sm:text-lg">
              Directive Pathway Advisors is a Melbourne-based consultancy dedicated to
              simplifying the journey of studying, working, and settling in Australia.
              We believe every student's pathway is unique — so we offer honest,
              tailored advice at every step, from choosing the right course to
              securing your visa and planning your long-term future here.
            </p>
          </Reveal>
          <Reveal delay={0.26}>
            <div className="mt-8 flex items-center gap-3 rounded-2xl border border-sky-100 bg-sky-50/70 p-5">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-sky-600 text-white">
                <MapPin className="h-5 w-5" />
              </span>
              <p className="text-sm text-slate-600">
                Based in the heart of <span className="font-semibold text-slate-900">Melbourne, VIC</span> —
                supporting students across Australia and around the world.
              </p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="relative">
            <div className="overflow-hidden rounded-3xl border border-sky-100 shadow-[0_30px_80px_rgba(2,132,199,0.18)]">
              <img
                src={ABOUT_IMG}
                alt="Advisor consulting with a student"
                className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-105"
              />
            </div>
            <motion.div
              animate={{ y: [0, -10, 0] }}
              transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
              className="absolute -bottom-6 -left-4 rounded-2xl border border-sky-200 bg-white/90 p-5 shadow-[0_20px_50px_rgba(2,132,199,0.2)] backdrop-blur-xl sm:-left-8"
            >
              <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.25em] text-sky-600">
                Our Promise
              </p>
              <p className="mt-1 font-display text-sm font-bold text-slate-900">
                Honest advice. Clear pathways. Real results.
              </p>
            </motion.div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
